
export enum NextActionType {
  NextStep = 'nextstep',
  MainPage = 'mainpage',
}
